module.exports = __webpack_public_path__ + "img/listItem2.7155d5ea.png";